import React, { useEffect, useRef, useState } from 'react'
import Layout from './Layout'
import DraggableList from 'react-draggable-list'
import DraggableItem from './DraggableItem'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_LESSON_PLANS, REORDER_LESSON_PLANS } from '../redux/lessonPlansReducer'
import { RootReducer } from '../redux/rootReducer'
import CreateLessonPlanButton from './CreateLessonPlanButton'
import LessonPlanListItem from './LessonPlanListItem'

type Props = {}

const UnitScreen = (props: Props) => {
  const { unitId } = useParams()
  const lessonPlans = useSelector((state: RootReducer) => {
    if (unitId) {
      return state.lessonPlansReducer.lessonPlans[Number(unitId)] || []
    }
    return []
  })

  const [list, setList] = useState(lessonPlans)
  const containerRef = useRef<HTMLDivElement>(null)
  const dispatch = useDispatch()

  useEffect(() => {
    setList(lessonPlans)
  }, [lessonPlans])

  useEffect(() => {
    if (unitId) {
      dispatch(FETCH_LESSON_PLANS({ unitId: Number(unitId) }))
    }
  }, [dispatch, unitId])

  const _onListChange = (newList: any) => {
    setList(newList)
    dispatch(REORDER_LESSON_PLANS({ unitId: Number(unitId), ids: newList.map((item: any) => item.id) }))
  }

  return (
    <Layout>
      <div className="flex justify-end">
        <CreateLessonPlanButton />
      </div>
      <div className="h-4" />
      <div ref={containerRef} style={{ touchAction: 'pan-y' }}>
        <DraggableList
          itemKey="id"
          //@ts-ignore
          template={DraggableItem}
          list={list}
          onMoveEnd={(newList: any) => _onListChange(newList)}
          container={() => containerRef.current}
          commonProps={{
            component: LessonPlanListItem
          }}
        />
      </div>
    </Layout>
  )
}

export default UnitScreen
